import { useEffect } from "react";

export const useOnResize = (onResize = () => {}) => {
  useEffect(() => {
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, [onResize]);
};
